import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaView } from "./ocurreguiaview";

class OcurreGuiasListNoRx extends React.PureComponent<{ value: models.GuiaDTO[] }> {
    render() {
        const guias = this.props.value;
        const guaisFXC = guias.filter(x => x.FletePorCobrar);
        const guiasPAG = guias.filter(x => !x.FletePorCobrar);


        const total = guaisFXC.map(x => x.Importes ? x.Importes.Total : 0).reduce((a, b) => a + b, 0);
        return (
            <div>
                <div className="row">
                    <div className="col-md-4">
                        <h3>Cantidad de guías: <label>{guias.length}</label></h3>
                    </div>
                    <div className="col-md-4">
                    </div>
                    <div className="col-md-4" style={{ textAlign: "right" }} >
                        <h3>Total a pagar: <label>{kea.formatCurrency(total)}</label></h3>
                    </div>
                </div>

                {
                    guaisFXC.length > 0 &&
                    <div>
                        <kea.Title titulo={`Fletes por cobrar (${guaisFXC.length})`} size="h3" line={true} />
                        {kea.autogrid(4, guaisFXC.map(x => <GuiaView value={x} />))}
                    </div>
                }
                {
                    guiasPAG.length > 0 &&
                    <div>
                        <kea.Title titulo={`Pagadas en origen (${guiasPAG.length})`} size="h3" line={true} />
                        {kea.autogrid(4, guiasPAG.map(x => <GuiaView value={x} />))}
                    </div>
                }
            </div>
        )
    }
}

const OcurreGuiasList = componentToRx(OcurreGuiasListNoRx);



export const OcurreGuias = OcurreGuiasList;



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/guias/ocurreguias.tsx